import React, {Component} from 'react';
import {v4 as uuidv4} from "uuid";
import {MechanicsView} from "./MechanicsView";
import {Forces} from "./Forces";
import {vector} from "./Vector";

export class SolarSystem extends Component {
    static displayName = SolarSystem.name;

    constructor(props) {
        super(props);
        const size = {width: 370, height: 370};
        const midX = size.width / 2;
        const midY = size.height / 2;
        const gravityConstant = 10;
        const forces = this.getForces(gravityConstant);
        const sun = this.createSun(20, 10000, midX, midY, 0, 0);
        this.state = {
            objects: [
                sun,
                this.createObjectInCircularOrbit(sun, gravityConstant, 2, 1, midX * 0.85, midY),
                this.createObjectInCircularOrbit(sun, gravityConstant, 2, 2, midX, midY * 0.8),
                this.createObjectInCircularOrbit(sun, gravityConstant, 3, 4, midX * 0.6, midY),
                this.createObjectInCircularOrbit(sun, gravityConstant, 5, 6, midX, midY * 0.4),
                this.createObjectInCircularOrbit(sun, gravityConstant, 7, 10, midX * 0.2, midY),
            ],
            forces: forces,
            size: size
        };
    }

    getForces = (gravityConstant) => {
        const force = Forces();
        return [force.gravitation(gravityConstant)];
    }

    createSun(radius, mass, x, y, vx = 0, vy = 0) {
        const id = uuidv4();
        return {
            id: id,
            r: {x, y, z: 0},
            v: {x: vx, y: vy, z: 0},
            radius: radius,
            m: mass,
            color: "yellow"
        };
    }

    createObjectInCircularOrbit(sun, gravityConstant, radius, mass, x, y) {
        // https://www.studysmarter.co.uk/explanations/physics/circular-motion-and-gravitation/
        const displacement = vector.add(sun.r, vector.multiply(vector.get(x, y), -1));
        const distance = Math.sqrt(vector.dot(displacement, displacement));
        const speed = Math.sqrt(gravityConstant * sun.m / distance);
        const direction = vector.multiply(vector.get(displacement.y, -displacement.x), 1 / distance);
        const velocity = vector.multiply(direction, speed);
        const id = uuidv4();
        return {
            id: id,
            r: {x, y, z: 0},
            v: velocity,
            radius: radius,
            m: mass,
            color: this.getRandomColor()
        };
    }

    getRandomColor() {
        // Gets a random color that's not too close to black or white: 
        const letters = '789ABCD';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * letters.length)];
        }
        return color;
    }

    render() {
        return (
            <div>
                <MechanicsView objects={this.state.objects} forces={this.state.forces}
                               size={this.state.size} animationTimeStep={2} dt={0.005}/>
            </div>
        );
    }
}
